import React from 'react';
import { string } from 'prop-types';

const YouTube = ({ src }) => {
  const vidSource = `https://www.youtube.com/embed/${src}?autoplay=1&rel=0&modestbranding=0`;
  return (
    <div className="video-container">
      <iframe
        className="player"
        title={`vid-${src}`}
        type="text/html"
        width="100%"
        height="100%"
        src={vidSource}
        frameBorder="0"
      />
    </div>
  );
};

YouTube.propTypes = {
  src: string.isRequired,
};

export default YouTube;



// WEBPACK FOOTER //
// ./src/components/YouTube.jsx